import { render, staticRenderFns } from "./RatecardsList.vue?vue&type=template&id=1d00073e&"
import script from "./RatecardsList.vue?vue&type=script&lang=js&"
export * from "./RatecardsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports